import { Accordion } from 'components/universal/accordion';
import { Button } from 'components/universal/button';
import { Checkbox } from 'components/universal/checkbox';
import { FormModal } from 'components/universal/form-modal';
import Heading from 'components/universal/heading';
import { Input } from 'components/universal/input';
import InputPasswodHideAndShow from 'components/universal/input-passwod-hide-and-show';
import Paragraph from 'components/universal/paragraph';
import { PASSWORD_ADNOTATION } from 'constants/validation-error-messages';
import { Controller } from 'react-hook-form';
import { components } from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { getWorkplaces } from 'services/registration';
import { ReactComponent as ArrowDown } from '../../assets/images/icon/icon-down.svg';
import { RegistrationClause } from './RegistrationClause';
import cls from './registration.module.scss';
import { useRegistrationHook } from './useRegistrationHook';
import cities from '../../utils/cities.json';
import Select from 'react-select';

const DropdownIndicator = (props) => {
    return (
        <>
            <components.DropdownIndicator {...props}>
                <ArrowDown />
            </components.DropdownIndicator>
        </>
    );
};

export const RegistrationView = () => {
    const {
        register,
        control,
        handleSubmit,
        onSubmit,
        errors,
        t,
        showPassword,
        showPasswordSecond,
        togglePassword,
        togglePasswordRepeat,
        onKeyUpHandle,
        setValueForm,
        openModal,
        goBack,
        setValue,
        setWorkplaceId,
        debouncedSearch,
        onChangeCity,
        debouncedSearchCity,
        debouncedSearchName,
        setSearchName,
        searchName,
        formatZipCode
    } = useRegistrationHook();
    
    return (
        <div className={cls.container}>
            <div className={cls.columnLeft}>
                <Heading
                    className={cls.heading}
                    headingLevel="h1"
                    headingStyle="h2"
                >
                    {t('registration.title')}
                </Heading>
                <Paragraph 
                    className={`${cls.paragraph} mb-10`}
                >
                    {t('registration.desc')}
                </Paragraph>
                <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                    <Heading 
                        headingLevel="h3" 
                        className={`${cls.heading2} mb-5`}
                    >
                        {t('registration.yourData')}
                    </Heading>
                    <div className={cls.formFields}>
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="first_name"
                            name="first_name"
                            label={t('registration.firstName')}
                            error={t(errors.first_name?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="last_name"
                            name="last_name"
                            label={t('registration.lastName')}
                            error={t(errors.last_name?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="email"
                            name="email"
                            label={t('registration.email')}
                            error={t(errors.email?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="phone"
                            name="phone"
                            label={t('registration.phone')}
                            error={t(errors.phone?.message)}
                            maxLength={255}
                        />
                        <InputPasswodHideAndShow
                            onClick={togglePassword}
                        >
                            <Input
                                className={`${cls.inputCustom} mb-6`}
                                register={register}
                                id="password"
                                name="password"
                                label={t('registration.password')}
                                error={t(errors.password?.message)}
                                maxLength={255}
                                type={!showPassword ? 'password' : 'text'}
                                adnotation={t(PASSWORD_ADNOTATION)}
                            />
                        </InputPasswodHideAndShow>
                        <InputPasswodHideAndShow
                            onClick={togglePasswordRepeat}
                        >
                            <Input
                                className={`${cls.inputCustom} mb-6`}
                                register={register}
                                id="password_repeat"
                                name="password_repeat"
                                label={t('registration.repeatPassword')}
                                error={t(errors.password_repeat?.message)}
                                maxLength={255}
                                type={!showPasswordSecond ? 'password' : 'text'}
                            />
                        </InputPasswodHideAndShow>
                    </div>
                    <Heading 
                        headingLevel="h3" 
                        className={`${cls.heading2} mb-5`}
                    >
                        {t('registration.workplaceData')}
                    </Heading>

                    <div className={`${cls.formFields} ${cls.formFieldsSecond}`}>
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_address_postcode"
                            name="workplace_address_postcode"
                            label={t('registration.zipCode')}
                            error={t(
                                errors.workplace_address_postcode?.message
                            )}
                            onKeyUp={onKeyUpHandle}
                            maxLength={6}
                            onChange={formatZipCode}
                        />
                        <div className={cls.select}>
                            <label htmlFor="workplace_address_city" className={cls.label}>
                                {t('registration.city')}
                            </label>
                            <Controller
                                name="workplace_address_city"
                                control={control}
                                render={({ field }) => (
                                <Select
                                    {...field}
                                    options={cities}
                                    className={errors.workplace_address_city ? 'error react-select-container' : 'react-select-container'}
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    components={{ DropdownIndicator }}
                                    onChange={(selected) => {
                                        onChangeCity(selected);
                                        setValue('workplace_name', null);
                                        return field.onChange(selected?.value)
                                    }}
                                    
                                    value={cities.find((c) => c.value === field.value) || null}
                                    noOptionsMessage={() => t('registration.noOptions')}
                                />
                                )}
                            />
                            {errors.workplace_address_city?.message && (
                                <p className={cls.errorBox}>{t(errors.workplace_address_city?.message)}</p>
                            )}
                        </div>
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="employee_position_name"
                            name="employee_position_name"
                            label={t('registration.position')}
                            error={t(errors.employee_position_name?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_name"
                            name="workplace_name"
                            label={t('registration.workplaceName')}
                            error={t(errors.workplace_name?.message)}
                            maxLength={255}
                        />
                        {/* <div className={cls.select}>
                            <label htmlFor="workplace_name" className={cls.label}>
                                {t('registration.workplaceName')}
                            </label>
                            <Controller
                                name="workplace_name"
                                control={control}
                                render={({ field }) => {
                                    const currentValue =
                                    typeof field.value === 'string'
                                      ? { workplace_name: field.value }
                                      : field.value;

                                    return (
                                        <AsyncPaginate
                                            key={`${debouncedSearch}-${debouncedSearchCity}`}
                                            value={currentValue}
                                            debounceTimeout={300}
                                            loadOptions={async (inputValue, loadedOptions, { page }) => {
                                                const response = await getWorkplaces({
                                                    name: debouncedSearchName,
                                                    postcode: debouncedSearch,
                                                    city: debouncedSearchCity,
                                                    page,
                                                });
                                            
                                                return {
                                                    options: response.data,
                                                    hasMore: response.current_page < response.last_page,
                                                    additional: {
                                                        page: response.current_page + 1,
                                                    },
                                                };
                                            }}
                                            additional={{ page: 1 }}
                                            getOptionLabel={(option: { workplace_name: any; }) => {
                                                return  option.workplace_name;
                                            }}
                                            getOptionValue={(option) => {
                                                return option.workplace_name;
                                            }}
                                            className={errors.workplace_name ? 'error react-select-container' : 'react-select-container'}
                                            classNamePrefix="react-select"
                                            placeholder=""
                                            components={{ DropdownIndicator }}
                                            noOptionsMessage={() => t('registration.noOptions')}
                                            onChange={(selectedOption) => {
                                                field.onChange(selectedOption.workplace_name);
                                                if (selectedOption) {
                                                    setValue('workplace_address_street', selectedOption.workplace_address_street);
                                                    setValue('workplace_address_number', selectedOption.workplace_address_number);
                                                    setValue('workplace_address_city', selectedOption.workplace_address_city);
                                                    setValue('workplace_address_postcode', selectedOption.workplace_address_postcode);
                                                    setWorkplaceId(selectedOption.id);
                                                }
                                            }}
                                            onInputChange={(newValue, { action }) => {
                                                if (action === 'input-change') {
                                                    setSearchName(newValue);
                                                }
                                                return newValue;
                                            }}
                                        />
                                    )
                                }}
                            />
                            <Paragraph 
                                className={`${cls.buttonWorkPlaceName} mb-10`}
                                onClick={openModal}
                            >
                                {t('registration.showPopupLabel')}
                            </Paragraph>
                        </div> */}
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_address_street"
                            name="workplace_address_street"
                            label={t('registration.street')}
                            error={t(errors.workplace_address_street?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_address_number"
                            name="workplace_address_number"
                            label={t('registration.apartmentNumber')}
                            error={t(errors.workplace_address_number?.message)}
                            maxLength={255}
                        />
                        
                    </div>
                    <Checkbox
                        className={cls.checkbox}
                        register={register}
                        id="agreement"
                        name="agreement"
                        label={t('registration.consent')}
                        error={t(errors.agreement?.message)}
                    />
                    <Accordion
                        label={t('registration.infoClause')}
                        arrow
                        height={300}
                        className={cls.accordion}
                    >
                        <RegistrationClause />
                    </Accordion>

                    <div className={cls.buttonWrapper}>
                        <Button 
                            className={`${cls.button} mx-auto mb-5`} 
                            styleType="border"
                            onClick={goBack}
                            type="button"
                        >
                            {t('resetPassword.goBackButton')}
                        </Button>
                        <Button className={cls.button} type="submit">
                            {t('registration.register')}
                        </Button>
                    </div>
                </form>
                <FormModal 
                    setValueForm={setValueForm}
                />
            </div>
        </div>
    );
};
